import React from 'react';
import { Box, Grid } from '@mui/material';
import SearchFilter from './SearchFilter';
import DateRangeFilter from './DateRangeFilters';
import DocumentStatusFilter from './DocumentStatusFilter';
import AdditionalFilters from './AdditionalFilters';

const DocumentListFilters = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
  selectedStatus,
  onStatusChange,
  dateRange,
  onDateRangeChange,
  includeResubmitted,
  onIncludeResubmittedChange,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');

  return (
    <Grid item xs={12} container justifyContent="space-between" alignItems="center" spacing={1}>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <DocumentStatusFilter value={selectedStatus} onChange={onStatusChange} />
        </Grid>
        <Grid>
          <DateRangeFilter value={dateRange} onChange={onDateRangeChange} />
        </Grid>
        <Grid item>
          <AdditionalFilters
            includeResubmitted={includeResubmitted}
            onIncludeResubmittedChange={onIncludeResubmittedChange}
          />
        </Grid>
      </Grid>
      <Grid item>
        <Box display="flex" gap={1} justifyContent="flex-end">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default DocumentListFilters;
